import { render, staticRenderFns } from "./gc-dashboard-transactions-card.vue?vue&type=template&id=5f7100a6&scoped=true"
import script from "./gc-dashboard-transactions-card.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-transactions-card.vue?vue&type=script&lang=js"
import style0 from "./gc-dashboard-transactions-card.vue?vue&type=style&index=0&id=5f7100a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7100a6",
  null
  
)

export default component.exports